import { Divider } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { useObserver } from 'mobx-react-lite';
import React, { useContext } from 'react';
import MobxContext from '../mobx/MobxContext';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 1100,
      margin: 'auto'
    },
    paper: {
      padding: 24
    },
    divider: {
      marginBottom: 16,
      marginTop: 8
    }
  })
);

function PreferencesPage() {
  const classes = useStyles({});
  const { preferenceStore } = useContext(MobxContext);

  const onThemeChange = (event, newTheme) => {
    preferenceStore.setTheme(newTheme);
  };

  return useObserver(() => (
    <div className={classes.root}>
      <Typography variant="h6" gutterBottom>Preferences</Typography>
      <Divider className={classes.divider} light />
      <Paper className={classes.paper}>
        <Typography variant="subtitle1" gutterBottom>Theme</Typography>
        <ToggleButtonGroup
          value={preferenceStore.theme}
          exclusive
          onChange={onThemeChange}
          aria-label="text alignment"
        >
          <ToggleButton value="light" aria-label="centered">
            Light
          </ToggleButton>
          <ToggleButton value="dark" aria-label="centered">
            Dark
          </ToggleButton>
        </ToggleButtonGroup>
      </Paper>
    </div>
  ));
};

export default PreferencesPage;
